module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS14.3db94f64.jpg";